import { FontFamily } from './font-family.js'

export * from './font-family.js'

export default FontFamily
